import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
  QueryList,
  ViewChildren,
} from '@angular/core';
import {
  CookingStoryCategorie,
  cookingStoryPageCategories,
  cookingstorySuggest,
} from 'src/app/core/model/api-response/cooking-story-model';
import { CookingStoryApiService } from 'src/app/data/repository/cooking-story/cooking-story-api.service';
import { CookingStoryGroceryApiService } from 'src/app/data/repository/cooking-story/cooking-story-kitchen-api.service';
import { CookingStoryService } from 'src/app/data/repository/cooking-story/cooking-story.service';
import { RecipeService } from 'src/app/data/repository/recipe-repository/recipe.service';

@Component({
  selector: 'app-cooking-story',
  templateUrl: './cooking-story.component.html',
  styleUrls: ['./cooking-story.component.scss'],
})
export class CookingStoryComponent implements OnInit, OnDestroy {
  public categories: CookingStoryCategorie[];
  public suggestPost: cookingstorySuggest;
  public pagePost: cookingStoryPageCategories[];
  public shadowNav: boolean = false;
  public dataReady: boolean = false;
  public isScrolled: boolean = false;
  public selectedCategorieId: string;
  public mrScrolled: boolean = false;
  firstTime = true;
  kitchensuggestPost: cookingStoryPageCategories;

  @ViewChild('scroolEl') scroolEl: ElementRef<HTMLDivElement>;
  @ViewChildren('categories') categoriesRef: QueryList<
    ElementRef<HTMLDivElement>
  >;
  constructor(
    private cookingStoryApiService: CookingStoryApiService,
    private recipeService: RecipeService,
    private cookingStoryService: CookingStoryService,
    private groceryApiService: CookingStoryGroceryApiService
  ) {
    this.load();
  }

  async ngOnInit() {}
  async load() {
    await this.cookingStoryApiService
      .getCookingStoryCategories()
      .then((res) => {
        this.categories = res.getData().getCookingStoryCategories().categories;
        let lastid = this.cookingStoryService.getCategorieId();
        if (lastid) {
          this.selectedCategorieId = lastid;
          this.cookingStoryService.saveCategorieId(this.selectedCategorieId);

          this.changeMenu(lastid);
        } else {
          this.selectedCategorieId = this.categories[0]._id;
          this.cookingStoryService.saveCategorieId(this.selectedCategorieId);
          this.changeMenu(this.selectedCategorieId);
        }
      });
  }
  public getPagePost(id: string) {
    this.cookingStoryApiService.getCookingStoryPosts(id).then((res) => {
      this.suggestPost = res.getData().getCookingStoryPage().suggestion;
      this.pagePost = res.getData().getCookingStoryPage().categories;
      this.dataReady = true;
    });
  }
  scrolling(data) {
    let scroolTop = this.scroolEl.nativeElement.scrollTop;
    if (scroolTop >= 150) {
      this.shadowNav = true;
    } else {
      this.shadowNav = false;
    }
  }
  changeMenu(id: string) {
    this.dataReady = false;

    this.selectedCategorieId = id;

    this.cookingStoryService.saveCategorieId(id);
    this.firstTime = false;
    this.getPagePost(id);
  }
  scrolled() {
    this.isScrolled = true;
  }
  goBack() {
    this.recipeService.back();
  }
  openRecipe(recipeId) {
    this.recipeService.goToRecipeDetail(recipeId);
  }
  showCategory(type: string, name: string, suggest: boolean) {
    let id;
    if (suggest) {
      id = this.suggestPost._id;
    } else {
      id = this.selectedCategorieId;
    }
    this.recipeService.goToCategory(id, type, name);
  }
  openSearch() {
    this.recipeService.goToCookingStorySearch();
  }
  goToFavorite() {
    this.recipeService.goToFavorite();
  }
  ngOnDestroy() {}
  getSelectedItem() {
    return this.categories.find((item) => item._id == this.selectedCategorieId);
  }
  isInView() {
    if (!this.categoriesRef) return false;
    let selected = this.categoriesRef
      .toArray()
      .find((item) => item.nativeElement.id == this.selectedCategorieId);
    let index = this.categoriesRef
      .toArray()
      .findIndex((item) => item.nativeElement.id == this.selectedCategorieId);

    if (selected) {
      if (
        selected.nativeElement.getBoundingClientRect().left < -60 ||
        selected.nativeElement.getBoundingClientRect().right >
          (window.innerWidth || document.documentElement.clientWidth) + 60
      ) {
        if (Math.ceil(this.categories.length / 2) < index) {
          this.mrScrolled = true;
        } else {
          this.mrScrolled = false;
        }
        return true;
      }
    }
    this.mrScrolled = false;
    return false;
  }
}
